import { getAxiosClientWithToken } from 'api';
import { FetchExchangeRequest } from 'types';

export const getExchange = (params: FetchExchangeRequest) => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/admin/meetings', { params });
};
